export const DATA_FOR_INDEX_LIST = {
  0: {space:2, type: "number"} ,
  1: {space:4, type: "letter"},
  2: {space:6, type: "romanize"},
  3: {space:8, type: "number"} ,
  4: {space:10, type: "letter"},
  5: {space:12, type: "romanize"},
  6: {space:14, type: "number"} ,
  7: {space:16, type: "letter"},
  8: {space:18, type: "romanize"},
  9: {space:20, type: "number"} ,
  10: {space:22, type: "letter"},
  11: {space:24, type: "romanize"}
}

export const DATA_FOR_INDEX_LIST_VI = {
  0: {type: "vi" ,space:2, } ,
  1: {type: "vi" ,space:4, },
  2: {type: "vi" ,space:6, },
  3: {type: "vi" ,space:8, } ,
  4: {type: "vi" ,space:10, },
  5: {type: "vi" ,space:12, },
  6: {type: "vi" ,space:14, } ,
  7: {type: "vi" ,space:16, },
  8: {type: "vi" ,space:18, },
  9: {type: "vi" ,space:20, } ,
  10:{type: "vi" ,space:22, },
  11:{type: "vi" ,space:24, }
}
export const NUMBERS_ROMANIZW = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1};
export const LETTERS = ['a','b','c','d','e','f','g','h','i','j','k','l', 'ñ','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
export const SIMBOL_VINIETA_SPACE= "• "
export const SIMBOL_VINIETA= "•"